import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "absolute top-5 left-5 z-50" }
const _hoisted_2 = { class: "w-full flex justify-center" }
const _hoisted_3 = { class: "flex flex-col gap-y-8" }
const _hoisted_4 = { class: "w-full flex justify-center" }

import { Popups } from '@/stores/Popup';
import BasePopupForm from '../Popup/BasePopupForm.vue';
import { EditProfile } from '@/stores/profile/EditProfile';
import AvatarUpload from '@/components/upload/AvatarUpload.vue';
import BaseCropper from '../Croper/BaseCropper.vue';
import BaseInput from '../form/BaseInput.vue';
import BaseBtn from '../button/baseBtn.vue';
import MessageCard from '../Message/messageCard.vue';
import { ref } from 'vue';
import BackFlash from '../back/BackFlash.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EditProfile',
  setup(__props) {

const dataPopup = Popups()
const dataEditProfile = EditProfile()
dataEditProfile.handelSetDataProfile()

const fileName = ref('')
const fileType = ref('')

function previewFile(imgFile: any) {
    dataEditProfile.updateProfile.srcCroper = ''
    fileName.value = ''
    fileType.value = ''
    let file = imgFile
    const reader = new FileReader();
    if (file) {
        reader.readAsDataURL(file);
    }
    reader.addEventListener(
        "load",
        () => {
            handelCroper()
            fileName.value = file.name
            fileType.value = file.type
            dataEditProfile.uploadAvatar.srcCroper = reader.result
        },
        false
    );

}

function handelCroper() {
    dataEditProfile.uploadAvatar.showCroper = true
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BasePopupForm, {
    status: _unref(dataPopup).showEditProfile,
    onClose: _cache[9] || (_cache[9] = ($event: any) => (_unref(dataPopup).showEditProfile = false)),
    title: "ویرایش پروفایل"
  }, {
    form: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(BackFlash, {
          colorIcon: "text-gray-500",
          reveres: true,
          onClick: _unref(dataPopup).handelEditProfile
        }, null, 8, ["onClick"])
      ]),
      _createElementVNode("form", {
        onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_unref(dataEditProfile).handelCheckProfileSubmited && _unref(dataEditProfile).handelCheckProfileSubmited(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(AvatarUpload, {
            "change-avatar": _unref(dataEditProfile).uploadAvatar.changeAvatar,
            loadImg: _unref(dataEditProfile).uploadAvatar.loading,
            srcPhotoCrop: _unref(dataEditProfile).uploadAvatar.srcCroper,
            srcAvatar: _unref(dataEditProfile).uploadAvatar.srcphoto,
            onPreviewFile: previewFile,
            onRemoveAvatar: _unref(dataEditProfile).handelRemoveAvatar
          }, null, 8, ["change-avatar", "loadImg", "srcPhotoCrop", "srcAvatar", "onRemoveAvatar"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(BaseCropper, {
            srcImgCroper: _unref(dataEditProfile).uploadAvatar.srcCroper,
            "show-popup-croper": _unref(dataEditProfile).uploadAvatar.showCroper,
            name: fileName.value,
            type: fileType.value,
            loading: _unref(dataEditProfile).uploadAvatar.loading,
            "show-card-message": _unref(dataEditProfile).uploadAvatar.errMessageCroper.showCardCroper,
            "data-err-croper": _unref(dataEditProfile).uploadAvatar.errMessageCroper.errMessage,
            onClose: _cache[0] || (_cache[0] = ($event: any) => (_unref(dataEditProfile).uploadAvatar.showCroper = false)),
            onSubmit: _unref(dataEditProfile).handelUploadAvatar
          }, null, 8, ["srcImgCroper", "show-popup-croper", "name", "type", "loading", "show-card-message", "data-err-croper", "onSubmit"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(BaseInput, {
            type: "text",
            label: "نام",
            "model-value": _unref(dataEditProfile).dataProfile.firstName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(dataEditProfile).dataProfile.firstName) = $event)),
            mandatory: true
          }, null, 8, ["model-value"]),
          _createVNode(BaseInput, {
            type: "text",
            label: "نام خانوادگی",
            "model-value": _unref(dataEditProfile).dataProfile.lastName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(dataEditProfile).dataProfile.lastName) = $event)),
            mandatory: true
          }, null, 8, ["model-value"]),
          _createVNode(BaseInput, {
            type: "number",
            label: "شماره تلفن همراه ",
            "model-value": _unref(dataEditProfile).dataProfile.mobile,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(dataEditProfile).dataProfile.mobile) = $event)),
            mandatory: true
          }, null, 8, ["model-value"]),
          _createVNode(BaseInput, {
            type: "number",
            label: "شماره همراه دوم",
            "model-value": _unref(dataEditProfile).dataProfile.secondPhone,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(dataEditProfile).dataProfile.secondPhone) = $event))
          }, null, 8, ["model-value"]),
          _createVNode(BaseInput, {
            type: "number",
            label: "شماره تلفن ثابت ",
            "model-value": _unref(dataEditProfile).dataProfile.homePhone,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(dataEditProfile).dataProfile.homePhone) = $event))
          }, null, 8, ["model-value"]),
          _createVNode(BaseInput, {
            type: "text",
            label: "شغل",
            "model-value": _unref(dataEditProfile).dataProfile.job,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(dataEditProfile).dataProfile.job) = $event))
          }, null, 8, ["model-value"]),
          _createVNode(BaseInput, {
            type: "number",
            label: "شماره تلفن محل کار ",
            "model-value": _unref(dataEditProfile).dataProfile.workPhone,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(dataEditProfile).dataProfile.workPhone) = $event))
          }, null, 8, ["model-value"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(BaseBtn, {
              type: "submit",
              styleBtn: "btn-confirm",
              text: "تایید",
              status: _unref(dataEditProfile).loading
            }, null, 8, ["status"])
          ])
        ])
      ], 32),
      _createVNode(MessageCard, {
        styleMessage: "message-error",
        icon: "warning.png",
        msg: _unref(dataEditProfile).err.errMessage,
        status: _unref(dataEditProfile).err.showCardMessage
      }, null, 8, ["msg", "status"]),
      _createVNode(MessageCard, {
        styleMessage: "message-success",
        icon: "success.png",
        msg: _unref(dataEditProfile).success.successMessage,
        status: _unref(dataEditProfile).success.showCardMessage
      }, null, 8, ["msg", "status"])
    ]),
    _: 1
  }, 8, ["status"]))
}
}

})